<script setup lang="ts">
import ClientsLogos from '~/components/global/ClientsLogos.vue'
import TailoredOfferFooterBanner from '~/components/global/TailoredOfferFooterBanner.vue'
import ReferencesListing from '~/components/references/listing/ReferencesListing.vue'
import ReferencesHeader from '~/components/references/listing/header/ReferencesHeader.vue'

const { t } = useI18n()

useHead({
  title: t('pages.references.header.title'),
})

useFancyHeader()

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/references',
    sk: '/referencie',
  },
})
</script>

<template>
  <div class="c-page-references">
    <ReferencesHeader class="c-page-references__header" />
    <ReferencesListing class="c-page-references__listing" />
    <ClientsLogos />
    <TailoredOfferFooterBanner
      :title="$t('tailoredOfferBanner.premisesTitle')"
    />
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-page-references {
  &__header {
    margin-bottom: 120px;

    @include breakpoint-down('lg') {
      margin-bottom: 80px;
    }

    @include breakpoint-down('md') {
      margin-bottom: 60px;
    }
  }

  &__listing {
    margin-bottom: 120px;

    @include breakpoint-down('lg') {
      margin-bottom: 80px;
    }
  }
}
</style>
